import { createReducer } from '@reduxjs/toolkit';
import { updateUserResponses } from './actions';
import { userResponsesInitialState } from './state';

export const userResponsesReducer = createReducer(userResponsesInitialState, (builder) => {
  builder.addCase(updateUserResponses, (state, { payload }) => ({
    ...state,
    ...payload,
  }));
});
